import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [showWechat, setShowWechat] = useState(false);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>关于我们</h4>
            <ul>
              <li><a href="/about">关于绘本馆</a></li>
              {/* <li><a href="/team">我们的团队</a></li> */}
              <li><a href="/contact">联系我们</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>服务</h4>
            <ul>
              <li><a href="/books">绘本推荐</a></li>
              <li><a href="/events">活动预约</a></li>
              <li><a href="/membership">会员服务</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>关注我们</h4>
            <div className="social-links">
              <div className="social-link" onClick={() => setShowWechat(true)}>📱 我们的社交账号</div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2022 - {currentYear} 养花怪兽阅读馆. All rights reserved.  蜀ICP备2020034348号</p>
        </div>
      </div>

      {showWechat && (
        <div className="qr-modal" onClick={() => setShowWechat(false)}>
          <div className="qr-content" onClick={e => e.stopPropagation()}>
            <div className="qr-images">
              <div>
                <img 
                  src="/images/social/wechat.jpg" 
                  alt="微信二维码" 
                  width="200" 
                  height="200"
                  loading="lazy"
                />
                <p>扫码关注我们的微信公众号</p>
              </div>
              <div>
                <img 
                  src="/images/social/xiaohongshu.jpg" 
                  alt="小红书二维码"
                  width="200" 
                  height="200"
                  loading="lazy"
                />
                <p>扫码关注我们的小红书账号</p>
              </div>
            </div>
            <button onClick={() => setShowWechat(false)}>关闭</button>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
